const captionCls = "_vcc148l26j";
const titleCls = "_vct14t06wj";
const spanCls = "_vcslucn7q";

export { captionCls, spanCls, titleCls };
import "./Caption.linaria.module.css";
//# sourceMappingURL=Caption.js.map
